package modysy

import modysy.simulation.Behaviours
import modysy.simulation.pp.{Output, PopulationProtocol, Rule, State}
import modysy.view.Color

/** Object containing the main function for a game playing around with population protocols */
object PPGame {

  /** Runs the game */
  def main(args: Array[String]): Unit = {
    new GameController().startGameLoop()
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/PPGame.scala